import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import sportApi from "../../services/sportApi";
import { showErrorSnackbar } from "./snackbarSlice";

export const getZoneTokens = createAsyncThunk('sport/getZoneTokens', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await sportApi.getZoneTokens(data);
        if (response.status === 0) {
            dispatch(fetchedZoneTokens()); // set Fetched to True
            return response?.data?.tokens; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
});

export const getAllPurchasedOrMyCartTokens = createAsyncThunk('sport/getAllPurchasedOrMyCartTokens', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await sportApi.getAllPurchasedOrMyCartTokens(data);
        if (response.status === 0) {
            dispatch(fetchedZoneTokens()); // set Fetched to True
            return response?.data?.tokens; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

export const getMatchesList = createAsyncThunk('sport/getMatchesList', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await sportApi.getMatchesList(data);
        if (response.status === 0) {
            return response?.data?.matches; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

export const getLiveMatchesList = createAsyncThunk('sport/getLiveMatchesList', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await sportApi.getLiveMatchesList(data);
        if (response.status === 0) {
            return response?.data?.matches; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})

export const getUserOwnedTokensList = createAsyncThunk('sport/getUserOwnedTokensList', async (data, { rejectWithValue, dispatch }) => {
    try {
        const response = await sportApi.getUserOwnedTokensList(data);
        if (response.status === 0) {
            dispatch(fetchedUserTokens()); // set Fetched to True
            return response?.data?.tokens; // Return the response data on success
        } else {
            // show error toast message
            dispatch(showErrorSnackbar({ title: response?.message }));
            return rejectWithValue(response?.message); // Reject with error message
        }
    } catch (error) {
        dispatch(showErrorSnackbar({ title: error?.message }));
        return rejectWithValue(error.message); // Handle unexpected errors
    }
})


const sportSlice = createSlice({
    name: 'sport',
    initialState: {
        isLoading: false,
        sport: null,
        zoneTokens: [],
        allTokens: [],
        zoneTokensFetched: false,
        matches: [],
        userTokens: [],
        userTokensFetched: false,
        error: null
    },
    reducers: {
        fetchedZoneTokens: (state) => {
            state.zoneTokensFetched = true;
        },
        fetchedUserTokens: (state) => {
            state.userTokensFetched = true;
        },
        addTokensFromCart: (state, action) => {
            const token = action.payload;
            state.allTokens = [...state.allTokens, token];
        },
        removeTokenFromSelectedTokens: (state, action) => {
            const token = action.payload;

            // xAxis: data?.tokenData[0]?.xAxis,
            //     yAxis:
            state.allTokens = state.allTokens.filter(t => !(t.xAxis === token.xAxis && t.yAxis === token.yAxis));
        } 
    },
    extraReducers: (builder) => {
        handleAsyncThunk(builder, getZoneTokens, 'zoneTokens', 'error', 'zoneTokensLoading'),
        handleAsyncThunk(builder, getMatchesList, 'matches', 'error', 'matchesLoading'),
        handleAsyncThunk(builder, getLiveMatchesList, 'liveMatches', 'error', 'liveMatchesLoading'),
        handleAsyncThunk(builder, getUserOwnedTokensList, 'userTokens', 'error', 'userTokensLoading'),
        handleAsyncThunk(builder, getAllPurchasedOrMyCartTokens, 'allTokens', 'error', 'allTokensLoading');
    }
})

export const { fetchedZoneTokens, fetchedUserTokens, addTokensFromCart, removeTokenFromSelectedTokens } = sportSlice.actions

export default sportSlice.reducer